module.exports = __webpack_public_path__ + "img/IDeltaT.bf6ae163.svg";